import { render, staticRenderFns } from "./EventItem.vue?vue&type=template&id=0b3d1146&scoped=true&"
import script from "./EventItem.vue?vue&type=script&lang=js&"
export * from "./EventItem.vue?vue&type=script&lang=js&"
import style0 from "./EventItem.vue?vue&type=style&index=0&id=0b3d1146&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b3d1146",
  null
  
)

export default component.exports